import { useEffect, useState } from "react";
import { TextAreaInput } from "swing-components";

import {
  ModalSubFeedbackBody,
  ModalSubFeedbackFooter,
  ModalSubFeedbackHeader,
  PositiveData,
  PositiveStep,
} from "~components/ModalSubFeedback";
import { translate } from "~utils";

/********* Types ********/
type ModalSubFeedbackContentPositiveCommentsProps = {
  onDismiss: () => void;
  onSubmit: (data: PositiveData) => void;
  positiveData: PositiveData;
  setPositiveData: (data: PositiveData) => void;
  setPositiveStep: (step: PositiveStep) => void;
  subName?: string;
  hasSubmissionError?: boolean;
};

/********* Component ********/
export function ModalSubFeedbackContentPositiveComments(
  props: ModalSubFeedbackContentPositiveCommentsProps,
) {
  const {
    onDismiss,
    positiveData,
    setPositiveData,
    setPositiveStep,
    subName,
    onSubmit: submitSubFeedbackForm,
    hasSubmissionError,
  } = props;

  /********* Hooks ********/
  const [_updatedComment, _setUpdatedComment] = useState(positiveData.comment ?? "");

  useEffect(() => {
    if (hasSubmissionError === false) setPositiveStep("summary");
  }, [hasSubmissionError, setPositiveStep]);

  /********* Handlers ********/
  function handleOnCommentChange(comment: string) {
    _setUpdatedComment(comment);
  }

  function handleOnSubmit() {
    const updatedData = {
      ...positiveData,
      ...(!!_updatedComment.trim() && { comment: _updatedComment }),
    };

    setPositiveData(updatedData);
    submitSubFeedbackForm(updatedData);
  }

  return (
    <>
      <ModalSubFeedbackHeader title={translate("GIVE_FEEDBACK_LABEL")} onDismiss={onDismiss} />
      <ModalSubFeedbackBody hasApiError={hasSubmissionError}>
        <div css={{ padding: "8px 0" }}>
          <TextAreaInput
            label={translate("MSF_POSITIVE_FEEDBACK_COMMENT_LABEL", subName)}
            value={_updatedComment}
            onChange={(comment: string) => handleOnCommentChange(comment)}
            placeholder={translate("MSF_COMMENT_TEXT_INPUT_PLACEHOLDER")}
          />
        </div>
      </ModalSubFeedbackBody>
      <ModalSubFeedbackFooter
        buttonPrimary={{
          onClick: handleOnSubmit,
          isDisabled: false,
          text: translate("LABEL_SUBMIT"),
        }}
        buttonSecondary={{
          onClick: () => {
            // Save the current comment before navigating back
            // Do not check if it's empty, if they cleared the
            // comment before navigating back, we would like to
            // keep that empty state.
            setPositiveData({ ...positiveData, comment: _updatedComment });
            setPositiveStep("reasons");
          },
          isDisabled: false,
          text: translate("LABEL_BACK"),
        }}
      />
    </>
  );
}
